import { Button } from "@/components/ui/button";
import { useProjectManagersAddUsersContext } from "@/modules/projects/components/managers/ProjectManagersAddUsersContext";
import { useCheckIsProjectLocked } from "@/modules/projects/hooks/useCheckIsProjectLocked";
import { UserPlus } from "lucide-react";
import { ComponentProps, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

interface AddManagersButtonProps {
  variant?: ComponentProps<typeof Button>["variant"];
}

const ProjectManagersAddUsersButtonComponent = ({
  variant = "outline",
}: AddManagersButtonProps) => {
  const { t } = useTranslation();
  const isProjectLocked = useCheckIsProjectLocked();
  const { setIsAddUsersDialogOpened } = useProjectManagersAddUsersContext();
  const openDialog = useCallback(() => {
    setIsAddUsersDialogOpened(true);
  }, [setIsAddUsersDialogOpened]);

  return (
    <Button
      onClick={openDialog}
      className="gap-2"
      variant={variant}
      size="sm"
      type="button"
      disabled={isProjectLocked}
    >
      <UserPlus className="w-5 h-5 mr-1" />
      {t("projects.managers.addUsers.button")}
    </Button>
  );
};

export const ProjectManagersAddUsersButton = memo(
  ProjectManagersAddUsersButtonComponent,
);
